
export { CookiesSnack } from "/home/runner/work/mangomap/mangomap/packages/ui-components/src/components/organisms/cookies-snack/index.tsx"